import './modal-style.scss'

import React from 'react'
import { Trans } from 'react-i18next'
import Modal from 'react-modal'

import Button from './button-modal'

export default function CalendarModal({ children, isOpen, onRequestClose }) {
  return (
    <Modal
      className="container-modal"
      isOpen={isOpen}
      ariaHideApp={false}
      onRequestClose={onRequestClose}
      shouldCloseOnOverlayClick={true}
    >
      <h2>
        <Trans i18nkey="article.add-to-calendar" />
      </h2>
      <div>{children}</div>
      <Button style={{ backgroundColor: '#fff' }} onClick={onRequestClose}>
        <Trans i18nkey="ui.buttons.cancel" />
      </Button>
    </Modal>
  )
}
